// generated from 7_337 samples

import { z } from "zod";
import { triggerFiltersGetSchema } from "./triggerFiltersGetSchema";

export const purchasedProductTriggerGetSchema = z.object({
  event_type: z.literal("TrackedUserBehavior::PurchasedProduct"),
  // null: 2_304 (31.40%)
  // true 6 (0.12%), false 5_027 (99.88%)
  blocklisted: z.boolean().nullable().optional(),
  // undefined: 6_620 (90.23%), defined 717 (9.77%)
  filter_description: z.string().optional(),
  // undefined: 6_620 (90.23%), defined 717 (9.77%)
  filters: triggerFiltersGetSchema.optional(),
  // null: 2_304 (31.40%)
  // true 8 (0.16%), false 5_025 (99.84%)
  hard_deleted: z.boolean().nullable().optional(),
  product_name: z.string(),
});
